import dynamic from 'next/dynamic'

export const BentoOne = dynamic(() => import('./bento-one'), { ssr: false })
